import { defineNuxtPlugin } from "nuxt/app";
import Vue3Toastify, { type ToastContainerOptions, toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default defineNuxtPlugin(nuxtApp => {
    const options = {
        autoClose: 1500,
        style: {
            opacity: "1",
            userSelect: "initial"
        },
        position: "bottom-right",
        limit: 1,
    } as ToastContainerOptions;

    nuxtApp.vueApp.use(Vue3Toastify, options);

    return {
        provide: { toast }
    };
});